/* eslint-disable */
<template>
  <div class="login-wrapper border-light">
    <form class="form-signin" @submit.prevent="resetPassword">
      <img class="login-logo" src="@/assets/jom-simple-logo-ios-splash-transparent.png">
      <label for="inputPassword" class="sr-only">Password</label>
      <input v-model="resetForm.password" type="password" id="inputPassword" class="form-control" placeholder="Password" required autofocus>
      <label for="inputPasswordConfirmation" class="sr-only">Password confirmation</label>
      <input v-model="resetForm.password_confirmation" type="password" id="inputPasswordConfirmation" class="form-control" placeholder="Password confirmation" required>
      <button class="btn btn-lg btn-primary btn-block" type="submit">Confirm</button>
    </form>
    <div id="divMessage">{{ errorMsg }} </div>
  </div>
</template>

<script>
import ApiService from '@/services/api/Mainapi'
export default {
/* eslint-disable */
  data () {
    return {
      resetForm: {
        password: '',
        password_confirmation: ''
      },
      rules: {
        required: value => !!value || '<text style="color:red">Required</text>',
        counter: value => value.length <= 20 || 'Max 20 characters'
      },
      errorMsg: ''
    }
  },
  methods: {
    resetPassword () {
      let urlParams = new URLSearchParams(window.location.search);
      let access_token_param = urlParams.get('access-token');
      let uid_param = urlParams.get('uid')
      let client_param = urlParams.get('client')
      console.log('access-token: ' + this.$route.query.client)
      if (this.checkValidation()) {
        $('#divMessage').addClass("alert").addClass("alert-danger")
        return;
      }
      this.performingRequest = true
      ApiService.resetPassword(this.resetForm.password, this.resetForm.password_confirmation, access_token_param, uid_param, client_param).then(user => {
        // alert(JSON.stringify(user))
        // localStorage.id = user.data.id
        // alert('LOGIN ID: ' + localStorage.getItem('id'))
        // this.$store.commit('setCurrentUser', user.data.id)
        // alert('store user id: ' + this.$store.currentUser)
        // this.performingRequest = false
        $('#divMessage').addClass("alert").addClass("alert-success")
        this.errorMsg = 'Your password was successfully changed'
      }).catch(err => {
        this.performingRequest = false
        $('#divMessage').addClass('alert').addClass('alert-danger')
        this.errorMsg = 'Something happened, please try again or contact contact@justonemore.app'
      })
    },
    checkValidation () {
      this.errorMsg = ''
      var validationErrors = false
      if (this.resetForm.password_confirmation != this.resetForm.password) {
        this.errorMsg = 'Passwords do not match - please check.'
        validationErrors = true
      }
      return validationErrors
    },
    addErrorMessage() {
      if (this.errorMsg == '') {
        this.errorMsg = "Sorry something went wrong. Please report if it continues"
      }
      $('#divMessage').addClass("alert").addClass("alert-danger")
    }
  }
}
</script>

<style lang="css">
  body {
    /* background: #f88f71; */
    background: white;
  }
  .login-wrapper {
    width: 70%;
    margin: 12% auto;
  }
  .form-signin {
    max-width: 330px;
    padding: 10% 15px;
    margin: 0 auto;
  }
  .form-signin .form-signin-heading,
  .form-signin .checkbox {
    margin-bottom: 10px;
  }
  .form-signin .checkbox {
    font-weight: normal;
  }
  .form-signin .form-control {
    position: relative;
    height: auto;
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
    padding: 10px;
    font-size: 16px;
  }
  .form-signin .form-control:focus {
    z-index: 2;
  }
  #inputPassword {
    outline: none !important;
    margin-bottom: 10px;
    border-radius: 20px;
  }
  #inputPasswordConfirmation {
    outline: none !important;
    margin-bottom: 30px;
    border-radius: 20px;
  }

  button {
    border: none !important;
    border-width: 0;
    border-radius: 20px !important;
    background-image: linear-gradient(to right, #F7BB97 0%, #DD5E89 80% )
  }

  
  .login-logo {
    max-width: -webkit-fill-available;
    /* max-width: 100%; */
    display: block;
    width: 100%;
    height: auto;
    margin-bottom: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue